import * as actionTypes from '../types/incoming';

export function getIncoming(payload) {
  return {
    type: actionTypes.GET_INCOMING,
    payload
  };
}

export function getIncomingSuccess(payload) {
  return {
    type: actionTypes.GET_INCOMING_SUCCESS,
    payload
  };
}

export function getIncomingFail(payload) {
  return {
    type: actionTypes.GET_INCOMING_FAIL,
    payload
  };
}

export function getIncomingAccept(payload) {
  return {
    type: actionTypes.GET_INCOMING_ACCEPT,
    payload
  };
}

export function getIncomingAcceptSuccess(payload) {
  return {
    type: actionTypes.GET_INCOMING_ACCEPT_SUCCESS,
    payload
  };
}

export function getIncomingAcceptFail(payload) {
  return {
    type: actionTypes.GET_INCOMING_ACCEPT_FAIL,
    payload
  };
}

export function getIncomingReject(payload) {
  return {
    type: actionTypes.GET_INCOMING_REJECT,
    payload
  };
}

export function getIncomingRejectSuccess(payload) {
  return {
    type: actionTypes.GET_INCOMING_REJECT_SUCCESS,
    payload
  };
}

export function getIncomingRejectFail(payload) {
  return {
    type: actionTypes.GET_INCOMING_REJECT_FAIL,
    payload
  };
}

export function getIncomingListAreas(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_AREAS,
    payload
  };
}

export function getIncomingListAreasSuccess(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_AREAS_SUCCESS,
    payload
  };
}

export function getIncomingListAreasFail(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_AREAS_FAIL,
    payload
  };
}

export function getIncomingListBoxes(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_BOXES,
    payload
  };
}

export function getIncomingListBoxesSuccess(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_BOXES_SUCCESS,
    payload
  };
}

export function getIncomingListBoxesFail(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_BOXES_FAIL,
    payload
  };
}

export function getIncomingListStocks(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_STOCKS,
    payload
  };
}

export function getIncomingListStocksSuccess(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_STOCKS_SUCCESS,
    payload
  };
}

export function getIncomingListStocksFail(payload) {
  return {
    type: actionTypes.GET_INCOMING_LIST_STOCKS_FAIL,
    payload
  };
}

export function getIncomingErrorFalse(payload) {
  return {
    type: actionTypes.GET_INCOMING_ERROR_FALSE,
    payload
  };
}

export function getIncomingUpdate(payload) {
  return {
    type: actionTypes.GET_INCOMING_UPDATE,
    payload
  };
}

export function getIncomingClear(payload) {
  return {
    type: actionTypes.GET_INCOMING_CLEAR,
    payload
  };
}
export function setInitialStateIncoming(payload) {
  return {
    type: actionTypes.SET_INITIAL_STATE_INCOMING,
    payload
  };
}
